// dashboard for config side of extension

import React, { useState, useEffect } from "react";
import QuizSelectionConfig from "./quizselectionconfig";

export default function ConfigDashboard(props) {
  return <QuizSelectionConfig {...props} />;
}
